import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.542 6.3h-.667v-.667a.667.667 0 1 0-1.333 0V6.3h-.667a.667.667 0 0 0 0 1.333h.667V8.3a.667.667 0 0 0 1.333 0v-.667h.667a.667.667 0 1 0 0-1.333m4.307.12a5.667 5.667 0 1 0-9.64 4.553l3.533 3.54a.666.666 0 0 0 .947 0l3.52-3.54a5.64 5.64 0 0 0 1.64-4.553m-2.574 3.613L8.21 13.1l-3.067-3.067a4.33 4.33 0 0 1-1.247-3.48 4.38 4.38 0 0 1 1.927-3.22 4.313 4.313 0 0 1 6.096 1.388 4.4 4.4 0 0 1 .604 1.819 4.33 4.33 0 0 1-1.247 3.493"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })